import { useRef } from 'react';

import { useCollectionManagementStore } from '@/store';
import appWorker from '@/worker';

const useImageCacheManager = () => {
  const { currentBucket, getStorageConfig } = useCollectionManagementStore();
  const imageCacheMapRef = useRef(
    new Map<
      string,
      {
        buffer: ArrayBuffer;
        height: number;
        mimeType: string;
        width: number;
      }
    >(),
  );

  const fetchImage = async (key: string) => {
    const { endpoint, idToken, tenant } = getStorageConfig();

    return appWorker
      .request('imageFetch', 'fetch', {
        url: key.startsWith('/') ? `${endpoint}${key}` : `${endpoint}/${key}`,
        header: {
          Authorization: `Bearer ${idToken}`,
          'X-Tenant-ID': tenant.id,
          'X-Bucket': currentBucket,
        },
        option: {
          cachingOption: {
            key,
          },
          resizeOption: {
            quality: 'low',
          },
        },
      })
      .then(res => {
        imageCacheMapRef.current.set(key, res);

        return res;
      });
  };

  const getImage = async (key: string) => {
    const data = imageCacheMapRef.current.get(key);

    if (data) return data;

    return fetchImage(key);
  };

  const clearImageCache = () => {
    imageCacheMapRef.current.clear();
  };

  return {
    clearImageCache,
    fetchImage,
    getImage,
  };
};

export default useImageCacheManager;
